import { SidebarPanelProps } from "../../../../../types/product";

export default function QuickStatsPanel({ form }: SidebarPanelProps) {
    const stats = [
        { label: "Name", value: `${(form.tab_name || "").length} chars` },
        { label: "Description", value: `${form.product_description.length} / 1000` },
        { label: "Specs", value: `${form.product_specifications.filter((s) => s.key.trim()).length} added` },
        { label: "Meta title", value: `${form.meta_title.length} / 60` },
    ];
    return (
        <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: 14, overflow: "hidden" }}>
            <div style={{ padding: "14px 20px", borderBottom: "1px solid var(--border)", background: "var(--section-header)" }}>
                <span style={{ fontSize: 14, fontWeight: 600, color: "var(--text)" }}>Quick Stats</span>
            </div>
            <div style={{ padding: "12px 16px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
                {stats.map((s) => (
                    <div key={s.label} style={{ background: "rgba(255,255,255,0.03)", borderRadius: 8, padding: "10px 12px" }}>
                        <div style={{ fontSize: 11, color: "var(--text3)", marginBottom: 4, textTransform: "uppercase", letterSpacing: "0.6px" }}>
                            {s.label}
                        </div>
                        <div style={{ fontSize: 14, fontWeight: 500, color: "var(--text2)" }}>{s.value}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}